import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';
import { useAuth } from './useAuth';

var VendorLanguageContext = createContext(null);

function VendorLanguageProvider(props) {
  var children = props.children;
  var auth = useAuth();
  var user = auth.user;

  var prefsState = useState({
    nativeLanguage: 'en',
    targetLanguage: 'th',
    displayMode: 'dual'
  });
  var preferences = prefsState[0];
  var setPreferences = prefsState[1];

  var langsState = useState([]);
  var supportedLanguages = langsState[0];
  var setSupportedLanguages = langsState[1];

  var loadingState = useState(true);
  var loading = loadingState[0];
  var setLoading = loadingState[1];

  var loadPreferences = useCallback(function() {
    if (!user || user.role !== 'vendor') {
      setLoading(false);
      return;
    }

    setLoading(true);
    
    Promise.all([
      api.get('vendor/language-preferences'),
      api.get('vendor/supported-languages')
    ])
    .then(function(results) {
      var prefs = results[0];
      var langs = results[1];
      
      setPreferences({
        nativeLanguage: prefs.native_language || 'en',
        targetLanguage: prefs.target_language || 'th',
        displayMode: prefs.language_display_mode || 'dual'
      });
      setSupportedLanguages(langs);
    })
    .catch(function(err) {
      console.error('Failed to load language preferences:', err);
    })
    .finally(function() {
      setLoading(false);
    });
  }, [user]);

  useEffect(function() {
    loadPreferences();
  }, [loadPreferences]);

  var updatePreferences = useCallback(function(newPrefs) {
    return api.put('vendor/language-preferences', {
      native_language: newPrefs.nativeLanguage || preferences.nativeLanguage,
      target_language: newPrefs.targetLanguage || preferences.targetLanguage,
      language_display_mode: newPrefs.displayMode || preferences.displayMode
    })
    .then(function(result) {
      setPreferences({
        nativeLanguage: result.native_language,
        targetLanguage: result.target_language,
        displayMode: result.language_display_mode
      });
      return result;
    });
  }, [preferences]);

  var value = {
    nativeLanguage: preferences.nativeLanguage,
    targetLanguage: preferences.targetLanguage,
    displayMode: preferences.displayMode,
    supportedLanguages: supportedLanguages,
    loading: loading,
    refresh: loadPreferences,
    updatePreferences: updatePreferences
  };

  return React.createElement(
    VendorLanguageContext.Provider,
    { value: value },
    children
  );
}

function useVendorLanguage() {
  var context = useContext(VendorLanguageContext);
  if (!context) {
    throw new Error('useVendorLanguage must be used within a VendorLanguageProvider');
  }
  return context;
}

export { VendorLanguageProvider, useVendorLanguage };
